import React, { useState } from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CloseIcon from '@mui/icons-material/Close';

const EnvasadoNoTerminadoSection = ({
  noTerminadoRecords,
  isFormOpen,
  setIsFormOpen,
  fechaMovimiento,
  setFechaMovimiento,
  botCaja,
  setBotCaja,
  marca,
  setMarca,
  noLoteGranel,
  setNoLoteGranel,
  loteEnvasado,
  setLoteEnvasado,
  categoria,
  setCategoria,
  clase,
  setClase,
  ingrediente,
  setIngrediente,
  edad,
  setEdad,
  tipoMaguey,
  setTipoMaguey,
  noAnalisis,
  setNoAnalisis,
  capacidad,
  setCapacidad,
  pctAlc,
  setPctAlc,
  invInicialCajas,
  setInvInicialCajas,
  invInicialBotellas,
  setInvInicialBotellas,
  entradaProcedencia,
  setEntradaProcedencia,
  entradaCajas,
  setEntradaCajas,
  entradaBotellas,
  setEntradaBotellas,
  salidaCajas,
  setSalidaCajas,
  salidaBotellas,
  setSalidaBotellas,
  salidaDestino,
  setSalidaDestino,
  invFinalCajas,
  setInvFinalCajas,
  invFinalBotellas,
  setInvFinalBotellas,
  mermas,
  setMermas,
  observaciones,
  setObservaciones,
  handleSaveNoTerminado,
  onCompleteEnvasado,
  onSaveHologramas
}) => {
  // MODAL 1: TERMINAR ENVASADO (SECCIÓN IV - IMÁGENES 2 Y 3)
  const [isTerminarModalOpen, setIsTerminarModalOpen] = useState(false);
  const [selectedRecordForTerminar, setSelectedRecordForTerminar] = useState(null);

  // Form states for Terminar Modal (Imágenes 2 y 3)
  const [tNoInformeAprobacion, setTNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [tFechaAprobacionEtiqueta, setTFechaAprobacionEtiqueta] = useState("2026-07-17");
  const [tClaseEtiqueta, setTClaseEtiqueta] = useState("Joven / Blanco");
  const [tIngredientesEtiqueta, setTIngredientesEtiqueta] = useState("Maguey Espadín");
  const [tTipoMagueyEtiqueta, setTTipoMagueyEtiqueta] = useState("Espadín");
  const [tPctAlcEtiqueta, setTPctAlcEtiqueta] = useState("48.5");
  const [tInvInicialCajas, setTInvInicialCajas] = useState("5");
  const [tInvInicialBotellas, setTInvInicialBotellas] = useState("60");
  const [tEntradaProcedencia, setTEntradaProcedencia] = useState("Etiquetado Lote NT-01");
  const [tEntradaCajas, setTEntradaCajas] = useState("15");
  const [tEntradaBotellas, setTEntradaBotellas] = useState("180");
  const [tSalidaDestino, setTSalidaDestino] = useState("Almacén de Producto Terminado");
  const [tSalidaCajas, setTSalidaCajas] = useState("10");
  const [tSalidaBotellas, setTSalidaBotellas] = useState("120");
  const [tObservaciones, setTObservaciones] = useState("Proceso de etiquetado completado y verificado.");

  // MODAL 2: CONTROL DE HOLOGRAMAS (SECCIÓN V - IMAGEN 4)
  const [isHologramasModalOpen, setIsHologramasModalOpen] = useState(false);
  const [selectedRecordForHologramas, setSelectedRecordForHologramas] = useState(null);

  // Form states for Hologramas Modal (Imagen 4)
  const [hInvInicialRango, setHInvInicialRango] = useState("A0123 - A0500");
  const [hInvInicialCant, setHInvInicialCant] = useState("378");
  const [hEntradaRango, setHEntradaRango] = useState("B0001 - B0500");
  const [hEntradaCant, setHEntradaCant] = useState("500");
  const [hSalidaRango, setHSalidaRango] = useState("A0123 - A0223");
  const [hSalidaCant, setHSalidaCant] = useState("101");
  const [hMermasRango, setHMermasRango] = useState("N/A");
  const [hMermasCant, setHMermasCant] = useState("0");
  const [hObservaciones, setHObservaciones] = useState("Hologramas aplicados e inventario actualizado.");

  // Handlers for opening modals
  const handleOpenTerminarModal = (rec) => {
    setSelectedRecordForTerminar(rec);
    setTClaseEtiqueta(rec.clase || "Joven / Blanco");
    setTIngredientesEtiqueta(rec.ingrediente || "Maguey Espadín");
    setTTipoMagueyEtiqueta(rec.tipoMaguey || "Espadín");
    setTPctAlcEtiqueta(rec.pctAlc || "48.5");
    setTEntradaProcedencia(`Etiquetado de lote ${rec.loteEnvasado}`);
    setIsTerminarModalOpen(true);
  };

  const handleConfirmTerminar = () => {
    if (!selectedRecordForTerminar) return;

    const initC = parseInt(tInvInicialCajas || 0, 10);
    const initB = parseInt(tInvInicialBotellas || 0, 10);
    const entC = parseInt(tEntradaCajas || 0, 10);
    const entB = parseInt(tEntradaBotellas || 0, 10);
    const salC = parseInt(tSalidaCajas || 0, 10);
    const salB = parseInt(tSalidaBotellas || 0, 10);

    const invFinalCajasCalc = Math.max(0, (initC + entC) - salC);
    const invFinalBotellasCalc = Math.max(0, (initB + entB) - salB);

    const finishedData = {
      noInformeAprobacion: tNoInformeAprobacion,
      fechaAprobacionEtiqueta: tFechaAprobacionEtiqueta,
      claseEtiqueta: tClaseEtiqueta,
      ingredientesEtiqueta: tIngredientesEtiqueta,
      tipoMagueyEtiqueta: tTipoMagueyEtiqueta,
      pctAlcEtiqueta: tPctAlcEtiqueta,
      invInicialCajas: tInvInicialCajas,
      invInicialBotellas: tInvInicialBotellas,
      entradaProcedencia: tEntradaProcedencia,
      entradaCajas: tEntradaCajas,
      entradaBotellas: tEntradaBotellas,
      salidaDestino: tSalidaDestino,
      salidaCajas: tSalidaCajas,
      salidaBotellas: tSalidaBotellas,
      invFinalCajas: invFinalCajasCalc.toString(),
      invFinalBotellas: invFinalBotellasCalc.toString(),
      observaciones: tObservaciones
    };

    if (onCompleteEnvasado) {
      onCompleteEnvasado(selectedRecordForTerminar, finishedData);
    }
    setIsTerminarModalOpen(false);
    alert(`¡Lote ${selectedRecordForTerminar.loteEnvasado} finalizado y registrado como Envasado Terminado (Sección IV)!`);
  };

  const handleOpenHologramasModal = (rec) => {
    setSelectedRecordForHologramas(rec);
    setIsHologramasModalOpen(true);
  };

  const handleConfirmHologramas = () => {
    if (!selectedRecordForHologramas) return;

    const initC = parseInt(hInvInicialCant || 0, 10);
    const entC = parseInt(hEntradaCant || 0, 10);
    const salC = parseInt(hSalidaCant || 0, 10);
    const merC = parseInt(hMermasCant || 0, 10);
    const finalCantCalc = Math.max(0, (initC + entC) - salC - merC);

    const hologramData = {
      invInicialRango: hInvInicialRango,
      invInicialCant: hInvInicialCant,
      entradaRango: hEntradaRango,
      entradaCant: hEntradaCant,
      salidaRango: hSalidaRango,
      salidaCant: hSalidaCant,
      mermasRango: hMermasRango,
      mermasCant: hMermasCant,
      invFinalRango: `A0224 - A0500, B0001 - B0500`,
      invFinalCant: finalCantCalc.toString(),
      observaciones: hObservaciones
    };

    if (onSaveHologramas) {
      onSaveHologramas(selectedRecordForHologramas, hologramData);
    }
    setIsHologramasModalOpen(false);
    alert(`¡Control de Hologramas asignado exitosamente al lote ${selectedRecordForHologramas.loteEnvasado} (Sección V)!`);
  };

  // Calculations for main form
  const initCajasNum = parseInt(invInicialCajas || 0, 10);
  const initBotNum = parseInt(invInicialBotellas || 0, 10);
  const entCajasNum = parseInt(entradaCajas || 0, 10);
  const entBotNum = parseInt(entradaBotellas || 0, 10);
  const salCajasNum = parseInt(salidaCajas || 0, 10);
  const salBotNum = parseInt(salidaBotellas || 0, 10);

  const calcFinalCajas = Math.max(0, (initCajasNum + entCajasNum) - salCajasNum);
  const calcFinalBotellas = Math.max(0, (initBotNum + entBotNum) - salBotNum);

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <div>
            <h2>Inventarios de Mezcal Envasado "No Terminado" (Sección III)</h2>
            <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "13px" }}>
              Botella desnuda / sin etiquetar. Desde la tabla puede <strong>Terminar Envasado</strong> (Sección IV) o asignar <strong>Hologramas</strong> (Sección V).
            </p>
          </div>
          <button
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro No Terminado</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="13" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Identificación del Mezcal</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Inventario Inicial</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Entradas</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Salidas</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Inventario Final</th>
                <th colSpan="5" style={{ textAlign: "center", background: "rgba(155, 89, 182, 0.2)", color: "#d5a6bd" }}>Trazabilidad & Acciones</th>
              </tr>
              <tr>
                {/* Identificación */}
                <th>Fecha Mov.</th>
                <th>Bot/Caja</th>
                <th>Marca</th>
                <th>Lote Granel</th>
                <th>Lote Env.</th>
                <th>Categoría</th>
                <th>Clase</th>
                <th>Ingrediente</th>
                <th>Edad</th>
                <th>Tipo Maguey</th>
                <th>Nº Análisis</th>
                <th>Capacidad</th>
                <th>% Alc. Vol.</th>

                {/* Inv Inicial */}
                <th>Cajas</th>
                <th>Botellas</th>

                {/* Entradas */}
                <th>Procedencia</th>
                <th>Cajas</th>
                <th>Botellas</th>

                {/* Salidas */}
                <th>Cajas</th>
                <th>Botellas</th>
                <th>Destino</th>

                {/* Inv Final */}
                <th>Cajas</th>
                <th>Botellas</th>

                {/* Cierre y Acciones */}
                <th>Mermas</th>
                <th>Observaciones</th>
                <th>Etapa Proceso</th>
                <th>Estatus COMERCAM</th>
                <th style={{ minWidth: "220px", textAlign: "center" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {noTerminadoRecords.map((rec, i) => {
                const stage = rec.estadoProceso || "no_terminado";
                return (
                  <tr key={i}>
                    <td>{rec.fechaMovimiento}</td>
                    <td>{rec.botCaja}</td>
                    <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                    <td>{rec.noLoteGranel}</td>
                    <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.loteEnvasado}</td>
                    <td>{rec.categoria}</td>
                    <td>{rec.clase}</td>
                    <td>{rec.ingrediente}</td>
                    <td>{rec.edad}</td>
                    <td>{rec.tipoMaguey}</td>
                    <td>{rec.noAnalisis}</td>
                    <td>{rec.capacidad}</td>
                    <td>{rec.pctAlc}%</td>

                    <td>{rec.invInicialCajas}</td>
                    <td>{rec.invInicialBotellas}</td>

                    <td>{rec.entradaProcedencia}</td>
                    <td>{rec.entradaCajas}</td>
                    <td>{rec.entradaBotellas}</td>

                    <td>{rec.salidaCajas}</td>
                    <td>{rec.salidaBotellas}</td>
                    <td>{rec.salidaDestino}</td>

                    <td style={{ color: "var(--agave-green)", fontWeight: 700 }}>{rec.invFinalCajas}</td>
                    <td style={{ color: "var(--agave-green)", fontWeight: 700 }}>{rec.invFinalBotellas}</td>

                    <td>{rec.mermas}</td>
                    <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {rec.observaciones}
                    </td>
                    <td>
                      <span className={`badge-stage ${stage}`}>
                        {stage === "hologramado" ? "🟢 Hologramado" : stage === "terminado" ? "🔵 Terminado" : "🟡 No Terminado"}
                      </span>
                    </td>
                    <td>
                      <span className={`badge-status ${rec.status}`}>
                        {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                        <button
                          onClick={() => handleOpenTerminarModal(rec)}
                          style={{
                            background: "linear-gradient(135deg, #d2691e 0%, #b85c14 100%)",
                            border: "none",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            fontSize: "11px",
                            fontWeight: 700,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}
                          title="Terminar Envasado (Asignar Etiqueta Aprobada - Imagen 2 y 3)"
                        >
                          <WorkspacePremiumIcon style={{ fontSize: 14 }} />
                          <span>Terminar</span>
                        </button>

                        <button
                          onClick={() => handleOpenHologramasModal(rec)}
                          style={{
                            background: "linear-gradient(135deg, #8e44ad 0%, #732d91 100%)",
                            border: "none",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            fontSize: "11px",
                            fontWeight: 700,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}
                          title="Control de Hologramas (Sección V - Imagen 4)"
                        >
                          <ConfirmationNumberIcon style={{ fontSize: 14 }} />
                          <span>Hologramas</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* MODAL 1: TERMINAR ENVASADO (SECCIÓN IV - IMÁGENES 2 Y 3) */}
        {isTerminarModalOpen && selectedRecordForTerminar && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.8)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}>
            <div style={{
              background: "var(--glass-bg, #1a2215)",
              border: "1px solid var(--glass-border, rgba(255,255,255,0.15))",
              borderRadius: "16px",
              width: "90%",
              maxWidth: "850px",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "24px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.6)"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "12px", marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <WorkspacePremiumIcon style={{ color: "var(--copper)", fontSize: 30 }} />
                  <div>
                    <h3 style={{ margin: 0, color: "var(--copper)", fontSize: "18px", fontWeight: 800 }}>
                      Terminar Envasado - Aprobación de Etiqueta (Sección IV)
                    </h3>
                    <small style={{ color: "var(--text-muted)" }}>
                      Lote: <strong>{selectedRecordForTerminar.loteEnvasado}</strong> | Granel: {selectedRecordForTerminar.noLoteGranel} | Marca: {selectedRecordForTerminar.marca}
                    </small>
                  </div>
                </div>
                <button onClick={() => setIsTerminarModalOpen(false)} style={{ background: "transparent", border: "none", color: "#aaa", cursor: "pointer" }}>
                  <CloseIcon />
                </button>
              </div>

              {/* APROBACIÓN DE ETIQUETA (IMAGEN 2) */}
              <div style={{ background: "rgba(210, 105, 30, 0.08)", padding: "16px", borderRadius: "12px", border: "1px solid rgba(210, 105, 30, 0.2)", marginBottom: "20px" }}>
                <h4 style={{ margin: "0 0 12px 0", color: "var(--copper)", fontSize: "14px", fontWeight: 700 }}>
                  1. Aprobación de Etiqueta (Imagen 2)
                </h4>
                <div className="species-grid" style={{ marginBottom: "12px" }}>
                  <div className="custom-input-group">
                    <input
                      type="text"
                      value={tNoInformeAprobacion}
                      onChange={e => setTNoInformeAprobacion(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. INF-APR-ET-102"
                    />
                    <label className="custom-input-label">Nº Informe de Aprobación de Etiqueta</label>
                  </div>

                  <div className="custom-input-group">
                    <input
                      type="date"
                      value={tFechaAprobacionEtiqueta}
                      onChange={e => setTFechaAprobacionEtiqueta(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Fecha de Aprobación</label>
                  </div>
                </div>

                <div className="species-grid">
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={tInvInicialCajas}
                      onChange={e => setTInvInicialCajas(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Cajas Iniciales</label>
                  </div>

                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={tInvInicialBotellas}
                      onChange={e => setTInvInicialBotellas(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Botellas Iniciales</label>
                  </div>
                </div>
              </div>

              {/* ENTRADAS, SALIDAS Y BALANCES (IMAGEN 3) */}
              <div style={{ background: "rgba(74, 93, 35, 0.08)", padding: "16px", borderRadius: "12px", border: "1px solid rgba(74, 93, 35, 0.2)", marginBottom: "20px" }}>
                <h4 style={{ margin: "0 0 12px 0", color: "var(--agave-green)", fontSize: "14px", fontWeight: 700 }}>
                  2. Entradas, Salidas y Saldos de Cierre (Imagen 3)
                </h4>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
                  <div>
                    <h5 style={{ margin: "0 0 8px 0", color: "var(--agave-green)", fontSize: "12px" }}>ENTRADAS</h5>
                    <div className="custom-input-group" style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        value={tEntradaProcedencia}
                        onChange={e => setTEntradaProcedencia(e.target.value)}
                        className="custom-input-field"
                      />
                      <label className="custom-input-label">Procedencia Entrada</label>
                    </div>
                    <div className="species-grid">
                      <div className="custom-input-group">
                        <input
                          type="number"
                          value={tEntradaCajas}
                          onChange={e => setTEntradaCajas(e.target.value)}
                          className="custom-input-field"
                        />
                        <label className="custom-input-label">Cajas Entrada</label>
                      </div>
                      <div className="custom-input-group">
                        <input
                          type="number"
                          value={tEntradaBotellas}
                          onChange={e => setTEntradaBotellas(e.target.value)}
                          className="custom-input-field"
                        />
                        <label className="custom-input-label">Botellas Entrada</label>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h5 style={{ margin: "0 0 8px 0", color: "var(--copper)", fontSize: "12px" }}>SALIDAS</h5>
                    <div className="custom-input-group" style={{ marginBottom: "10px" }}>
                      <input
                        type="text"
                        value={tSalidaDestino}
                        onChange={e => setTSalidaDestino(e.target.value)}
                        className="custom-input-field"
                      />
                      <label className="custom-input-label">Destino Salida</label>
                    </div>
                    <div className="species-grid">
                      <div className="custom-input-group">
                        <input
                          type="number"
                          value={tSalidaCajas}
                          onChange={e => setTSalidaCajas(e.target.value)}
                          className="custom-input-field"
                        />
                        <label className="custom-input-label">Cajas Salida</label>
                      </div>
                      <div className="custom-input-group">
                        <input
                          type="number"
                          value={tSalidaBotellas}
                          onChange={e => setTSalidaBotellas(e.target.value)}
                          className="custom-input-field"
                        />
                        <label className="custom-input-label">Botellas Salida</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="custom-input-group">
                  <textarea
                    value={tObservaciones}
                    onChange={e => setTObservaciones(e.target.value)}
                    className="custom-input-field"
                    style={{ height: "65px", resize: "none" }}
                  />
                  <label className="custom-input-label">Observaciones generales</label>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                <button onClick={() => setIsTerminarModalOpen(false)} className="btn-secondary-custom">Cancelar</button>
                <button onClick={handleConfirmTerminar} className="btn-primary-custom" style={{ background: "linear-gradient(135deg, #d2691e 0%, #b85c14 100%)" }}>
                  <WorkspacePremiumIcon style={{ fontSize: 16 }} />
                  <span>Guardar Envasado Terminado (Sección IV)</span>
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL 2: CONTROL DE HOLOGRAMAS (SECCIÓN V - IMAGEN 4) */}
        {isHologramasModalOpen && selectedRecordForHologramas && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.8)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}>
            <div style={{
              background: "var(--glass-bg, #1a2215)",
              border: "1px solid var(--glass-border, rgba(255,255,255,0.15))",
              borderRadius: "16px",
              width: "90%",
              maxWidth: "850px",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "24px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.6)"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "12px", marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <ConfirmationNumberIcon style={{ color: "#8e44ad", fontSize: 30 }} />
                  <div>
                    <h3 style={{ margin: 0, color: "#8e44ad", fontSize: "18px", fontWeight: 800 }}>
                      Control del Inventario de Hologramas (Sección V - Imagen 4)
                    </h3>
                    <small style={{ color: "var(--text-muted)" }}>
                      Asociado a Lote: <strong>{selectedRecordForHologramas.loteEnvasado}</strong> | Marca: {selectedRecordForHologramas.marca}
                    </small>
                  </div>
                </div>
                <button onClick={() => setIsHologramasModalOpen(false)} style={{ background: "transparent", border: "none", color: "#aaa", cursor: "pointer" }}>
                  <CloseIcon />
                </button>
              </div>

              {/* RANGOS E INVENTARIO (IMAGEN 4) */}
              <div style={{ background: "rgba(142, 68, 173, 0.08)", padding: "16px", borderRadius: "12px", border: "1px solid rgba(142, 68, 173, 0.2)", marginBottom: "20px" }}>
                <h4 style={{ margin: "0 0 12px 0", color: "#8e44ad", fontSize: "14px", fontWeight: 700 }}>
                  Inventario Inicial y Entradas de Hologramas
                </h4>

                <div className="species-grid" style={{ marginBottom: "12px" }}>
                  <div className="custom-input-group">
                    <input
                      type="text"
                      value={hInvInicialRango}
                      onChange={e => setHInvInicialRango(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. A0123 - A0500"
                    />
                    <label className="custom-input-label">Rango Inicial</label>
                  </div>
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={hInvInicialCant}
                      onChange={e => setHInvInicialCant(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Cantidad Inicial</label>
                  </div>
                </div>

                <div className="species-grid">
                  <div className="custom-input-group">
                    <input
                      type="text"
                      value={hEntradaRango}
                      onChange={e => setHEntradaRango(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. B0001 - B0500"
                    />
                    <label className="custom-input-label">Rango Entrada (Asignación)</label>
                  </div>
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={hEntradaCant}
                      onChange={e => setHEntradaCant(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Cantidad Entrada</label>
                  </div>
                </div>
              </div>

              {/* CONSUMO, MERMAS Y BALANCE (IMAGEN 4) */}
              <div style={{ background: "rgba(74, 93, 35, 0.08)", padding: "16px", borderRadius: "12px", border: "1px solid rgba(74, 93, 35, 0.2)", marginBottom: "20px" }}>
                <h4 style={{ margin: "0 0 12px 0", color: "var(--agave-green)", fontSize: "14px", fontWeight: 700 }}>
                  Consumo (Salidas), Mermas y Balance Final
                </h4>

                <div className="species-grid" style={{ marginBottom: "12px" }}>
                  <div className="custom-input-group">
                    <input
                      type="text"
                      value={hSalidaRango}
                      onChange={e => setHSalidaRango(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. A0123 - A0223"
                    />
                    <label className="custom-input-label">Rango Consumido (Aplicados)</label>
                  </div>
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={hSalidaCant}
                      onChange={e => setHSalidaCant(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Cantidad Consumida</label>
                  </div>
                </div>

                <div className="species-grid" style={{ marginBottom: "12px" }}>
                  <div className="custom-input-group">
                    <input
                      type="text"
                      value={hMermasRango}
                      onChange={e => setHMermasRango(e.target.value)}
                      className="custom-input-field"
                      placeholder="Ej. N/A o A0224 - A0225"
                    />
                    <label className="custom-input-label">Rango Mermas (Dañados)</label>
                  </div>
                  <div className="custom-input-group">
                    <input
                      type="number"
                      value={hMermasCant}
                      onChange={e => setHMermasCant(e.target.value)}
                      className="custom-input-field"
                    />
                    <label className="custom-input-label">Cantidad Mermada</label>
                  </div>
                </div>

                <div className="custom-input-group">
                  <textarea
                    value={hObservaciones}
                    onChange={e => setHObservaciones(e.target.value)}
                    className="custom-input-field"
                    style={{ height: "65px", resize: "none" }}
                  />
                  <label className="custom-input-label">Observaciones sobre hologramas</label>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                <button onClick={() => setIsHologramasModalOpen(false)} className="btn-secondary-custom">Cancelar</button>
                <button onClick={handleConfirmHologramas} className="btn-primary-custom" style={{ background: "linear-gradient(135deg, #8e44ad 0%, #732d91 100%)" }}>
                  <ConfirmationNumberIcon style={{ fontSize: 16 }} />
                  <span>Guardar Control Hologramas (Sección V)</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // VISTA DE FORMULARIO DE CAPTURA INICIAL (IMAGEN 1 - SECCIÓN III)
  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nuevo Registro de Envasado No Terminado - Sección III</h2>
      </div>

      <div className="cards-container-grid">
        {/* IDENTIFICACIÓN (IMAGEN 1) */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Identificación del Mezcal y Lote (Imagen 1)</h2>
              <p>Datos del envasado e ingrediente en etiqueta</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="date"
                value={fechaMovimiento}
                onChange={e => setFechaMovimiento(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha del Movimiento</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                value={botCaja}
                onChange={e => setBotCaja(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. 12 botellas"
              />
              <label className="custom-input-label">Botellas por Caja (Bot/Caja)</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                value={marca}
                onChange={e => setMarca(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. Don Julio Mezcal"
              />
              <label className="custom-input-label">Marca Comercial</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                value={noLoteGranel}
                onChange={e => setNoLoteGranel(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. PROD-LOTE-01"
              />
              <label className="custom-input-label">Nº Lote a Granel</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                value={loteEnvasado}
                onChange={e => setLoteEnvasado(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. L-01-ENV-T"
              />
              <label className="custom-input-label">Lote de Envasado</label>
            </div>

            <div className="custom-input-group">
              <select
                value={categoria}
                onChange={e => setCategoria(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select
                value={clase}
                onChange={e => setClase(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Joven / Blanco">Joven / Blanco</option>
                <option value="Madurado en Vidrio">Madurado en Vidrio</option>
                <option value="Reposado">Reposado</option>
                <option value="Añejo">Añejo</option>
                <option value="Abocado con">Abocado con</option>
                <option value="Destilado con">Destilado con</option>
              </select>
              <label className="custom-input-label">Clase en Etiqueta</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                value={ingrediente}
                onChange={e => setIngrediente(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. Maguey Espadín"
              />
              <label className="custom-input-label">Ingrediente(s) en Etiqueta</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                value={edad}
                onChange={e => setEdad(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. Sin edad / Reposado 6 meses"
              />
              <label className="custom-input-label">Edad (Meses o Años)</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                value={tipoMaguey}
                onChange={e => setTipoMaguey(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. Espadín"
              />
              <label className="custom-input-label">Tipo de Maguey(es) en Etiqueta</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="text"
                value={noAnalisis}
                onChange={e => setNoAnalisis(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. ANA-2026-098"
              />
              <label className="custom-input-label">Nº de Análisis Fisicoquímico</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                value={capacidad}
                onChange={e => setCapacidad(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. 750 ml"
              />
              <label className="custom-input-label">Capacidad</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input
              type="number"
              step="0.1"
              value={pctAlc}
              onChange={e => setPctAlc(e.target.value)}
              className="custom-input-field"
            />
            <label className="custom-input-label">% Alc. Vol. en Etiqueta</label>
            <span className="input-suffix">%</span>
          </div>
        </section>

        {/* MOVIMIENTOS E INVENTARIO BASE */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <ShoppingBagIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inventario Inicial y Movimientos</h2>
              <p>Saldos de inicio, entradas y mermas en línea de envasado</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                value={invInicialCajas}
                onChange={e => setInvInicialCajas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Cajas Iniciales</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={invInicialBotellas}
                onChange={e => setInvInicialBotellas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Botellas Iniciales</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 16 }}>
            <input
              type="text"
              value={entradaProcedencia}
              onChange={e => setEntradaProcedencia(e.target.value)}
              className="custom-input-field"
              placeholder="Ej. Línea de Envasado 1"
            />
            <label className="custom-input-label">Procedencia de Entrada</label>
          </div>

          <div className="species-grid" style={{ marginTop: 12 }}>
            <div className="custom-input-group">
              <input
                type="number"
                value={entradaCajas}
                onChange={e => setEntradaCajas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Cajas Entrada</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={entradaBotellas}
                onChange={e => setEntradaBotellas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Botellas Entrada</label>
            </div>
          </div>

          <hr style={{ border: 0, borderBottom: "1px solid var(--glass-border)", margin: "20px 0" }} />

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                value={salidaCajas}
                onChange={e => setSalidaCajas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Cajas Salida</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={salidaBotellas}
                onChange={e => setSalidaBotellas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Botellas Salida</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input
              type="text"
              value={salidaDestino}
              onChange={e => setSalidaDestino(e.target.value)}
              className="custom-input-field"
              placeholder="Ej. Área de Etiquetado y Hologramas"
            />
            <label className="custom-input-label">Destino de Salida</label>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input
              type="text"
              value={mermas}
              onChange={e => setMermas(e.target.value)}
              className="custom-input-field"
              placeholder="Ej. 2 botellas (rotura en línea)"
            />
            <label className="custom-input-label">Mermas (Botellas dañadas)</label>
          </div>
        </section>

        {/* INVENTARIO FINAL CALCULADO & RESUMEN */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <CheckCircleIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inventario Final Calculado y Observaciones</h2>
              <p>Saldo final de botellas desnudas sin etiquetar</p>
            </div>
          </header>

          <div className="species-grid" style={{ marginTop: 12 }}>
            <div className="custom-input-group">
              <input
                type="number"
                value={calcFinalCajas}
                readOnly
                className="custom-input-field"
                style={{ opacity: 0.9, fontWeight: 700, color: "var(--agave-green)" }}
              />
              <label className="custom-input-label">Nº Cajas Finales (Calculado)</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={calcFinalBotellas}
                readOnly
                className="custom-input-field"
                style={{ opacity: 0.9, fontWeight: 700, color: "var(--agave-green)" }}
              />
              <label className="custom-input-label">Nº Botellas Finales (Calculado)</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea
              value={observaciones}
              onChange={e => setObservaciones(e.target.value)}
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales sobre el lote de envasado no terminado..."
            />
            <label className="custom-input-label">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button
          type="button"
          className="btn-primary-custom"
          onClick={() => handleSaveNoTerminado("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Guardar Envasado No Terminado (Sección III)</span>
        </button>
      </div>
    </div>
  );
};

export default EnvasadoNoTerminadoSection;
